import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';
import { AidaEligibility } from '@ps/survey-utils';

import { AidaEligibilityDto } from './dtos/aida-eligibility.dto';
import { AidaEligibilityMapper } from './mappers/aida-eligibility.mapper';

@Injectable({ providedIn: 'root' })
export class AidaApi {
  private readonly _env = inject(ENV_CONFIG);
  private readonly _http = inject(HttpClient);

  private readonly _baseUrl = `${this._env.pureSpectrum.url}/buyers/v2/aida`;

  private readonly _mapper = new AidaEligibilityMapper();

  // No loading context: runs unprompted on page load and only feeds the AI
  // section, so a global overlay would block the page for it.
  public eligibilityCheck(surveyId: number): Observable<AidaEligibility> {
    return this._http
      .get<AidaEligibilityDto>(`${this._baseUrl}/eligibility-check/${surveyId}`)
      .pipe(map((dto) => this._mapper.fromDto(dto)));
  }
}
